export default __webpack_public_path__ + "static/media/pathBanner.c4016c78.png";